import styled from "styled-components/macro";
import DesignConstants from "../../constants/DesignConstants";
export const Header = styled.header`
    padding: ${DesignConstants.SPACES.XS} ${DesignConstants.SPACES.S};
    display: flex;
    align-items: center;
    height: 60px;
    width: 100%;
    position: sticky;
    top: 0;
    box-shadow: 0 3px 3px rgb(0 0 0 / 10%);
    background-color: white;
    z-index: 1000;
`;

export const PageWrapper = styled.div`
    width: 100%;
    min-height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;

    &.fill {
        height: 100%;
        min-height: 100vh;
    }

    &.pinned-footer {
        height: 100vh;
        max-height: 100vh;
        overflow: hidden;
    }

    &.gray {
        background: ${DesignConstants.COLORS.BACKGROUND_LIGHT};
    }
`;

export const IFrameHeaderPlaceholder = styled.div`
    width: 100%;
    height: ${DesignConstants.SPACES.S};
    background: ${DesignConstants.COLORS.BACKGROUND_LIGHT};
    top: 0;
    z-index: 1;
`;
